export const validaSessao = {
    methods: {
        async validaSessao (metodo) {
            let resp = await this.$store.dispatch('sessao/validaSessao')
            resp.data.status === true ? this[metodo]() : window.location.href = "/painel"
        }
    }
}